<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    truncateLimit: {
      type: Number,
      default: 45,
    },
    icon: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  computed: {
    displayText() {
      if (this.text.length > this.truncateLimit) {
        return this.isExpanded
          ? this.text
          : this.text.substring(0, this.truncateLimit) + '...'
      }

      return this.text
    },
    canToggleText() {
      return this.text.length > this.truncateLimit
    },
  },
  methods: {
    toggleText() {
      this.isExpanded = !this.isExpanded
    },
  },
}
</script>

<template>
  <span>
    <v-icon v-if="icon.length" size="18">{{ icon }}</v-icon>

    <span :key="isExpanded">
      {{ displayText }}
    </span>

    <span
      v-if="canToggleText"
      class="primary--text text--darken-2 font-weight-medium cursor-pointer"
      style="margin-left: 4px"
      @click="toggleText"
    >
      {{ isExpanded ? 'See less' : 'See more' }}
    </span>
  </span>
</template>
